import React from 'react'
import styles from './EdofSection12.module.css'
const data = [
    {
        title: "High Success Rate",
        desc: "+80% first fitting success rate",
        icon: "/svg/star_icon.svg",
    },
     {
        title: "Easy Transition",
        desc: "Supports fewer prescription adjustments & fine-tuning complexity for fitters",
        icon: "/svg/Transition_icon.svg",
    },
    {
        title: "Versatility",
        desc: "Delivers statistically significant improvements in continuous focus at near and intermediate distances. Clarity is preserved in diverse lighting conditions.",
        icon: "/svg/Versatility_icon.svg",
    },
    {
        title: "Better for your practice",
        desc: "Reduced Patient Chair Time to around 20 minutes on first visit.",
        icon: "/svg/practice_icon.svg",
    },
    {
        title: "Less Inventory, Lower Cost",
        desc: "Fewer SKUs required: 180+ SKUs for multifocal contact lenses vs. 61 SKUs for Desyne® EDOF contact lenses.",
        icon: "/svg/dollor_icon.svg",
    },
    {
        title: "True Comfort",
        desc: "Inclusion of LacriMass™ and FusionTechnology™ supports comfort and all-day wearability.",
        icon: "/svg/True-Comfot.svg",
        highlight: true,
    },
];

const EdofSection12 = () => {
    return (
        <div className={styles.containerBox}>
           
            <div className={styles.container}>
                {data.map((item, index) => (
                    <div
                        key={index}
                        className={`${styles.card} ${item.highlight ? styles.highlight : ""
                            }`}
                    >
                        <div className={styles.icon}><img src={item.icon} alt='' loading="lazy" decoding="async" /></div>
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default EdofSection12
